// extracted by mini-css-extract-plugin
export var adminPanel = "admin-panel-module--admin-panel---iCtG";